import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {OG_PATH} from "@/content";

const slug = 'level-2-electrical-new-connections-disconnections';
const serviceId = 1
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {
    const metaTags : MetaTagsProps =  {
        title: "New Connections & Disconnections",
        description: "Connecting or disconnecting properties to the electricity network, essential for new builds or renovations.",
        keywords: "new electrical connections Sydney, electrical disconnections Sydney, licensed electricians Sydney, residential electrical connections, commercial electrical connections, safe electrical disconnections, professional electricians Sydney",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Level 2 New Connections & Disconnections',
    description: 'Connecting or disconnecting properties to the electricity network, essential for new builds or renovations.',
    points: [],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
